/// <reference types="google-maps" />

import React from 'react';
import { useLocalization } from 'Douleutaras/hooks/localization';
import { isTwoGisEnabled } from 'Douleutaras/configuration/twoGis';
import { Gis } from 'Douleutaras/components/Forms/gis.class';

import { GoogleLocationMap } from './GoogleLocationMap';
import { TwoGisLocationMap } from './TwoGisLocationMap';

interface LocationMapProps {
  // Initial map center. When absent, the country's default center is used.
  center?: google.maps.LatLngLiteral;
  // When true, a newly provided `center` is reverse-geocoded and emitted through
  // `onChange` (used when the center comes from the device location).
  resolveCenter?: boolean;
  onChange(gis: Gis): void;
}

/**
 * Provider switcher for the interactive location map: 2GIS for Cyprus (where Google
 * Maps coverage is poor), Google everywhere else. Both variants share the same
 * `center`/`resolveCenter`/`onChange` contract.
 */
export const LocationMap = (props: LocationMapProps) => {
  const { countryCode } = useLocalization();

  return isTwoGisEnabled(countryCode)
    ? <TwoGisLocationMap {...props} />
    : <GoogleLocationMap {...props} />;
};

export default LocationMap;
